import BottomBar from './BottomBar';
import { connect } from 'shared/node_modules/react-redux';
import { setTutorialStep } from 'shared/state/slices/tutorial/tutorial';
import { setPosition } from 'shared/state/slices/animations/animations';

const mapStateToProps = state => {
  return {
    onboardingsSeen: state.ftue.onboardingsSeen[state.playerInfo.playerId] || [],
    missionsData: state.missions.data,
    missionsAssets: state.assetsPackage.assets.MISSIONS_FEATURE,
    activeTutorial: state.tutorial.activeTutorial,
    tutorialStep: state.tutorial.tutorialStep,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setTutorialStep: value => {
      dispatch(setTutorialStep(value));
    },
    setPosition: position => {
      dispatch(setPosition(position));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomBar);

